export default __webpack_public_path__ + "static/media/compas_dashboard_search_prospect.9ebc6082.gif";